export const state = {
  activePrimaryNav: {},
  activePrimaryNavIndex: 0,
  primaryNavContent: [
    {
      title: null,
      component: null,
    },
  ],
};

export const getters = {};

export const mutations = {
  pushPrimaryNavContent(state, newNav) {
    state.primaryNavContent.push(newNav);
  },
  popPrimaryNavContent(state) {
    state.primaryNavContent.pop();
  },
  setActivePrimaryNav(state, activeNav) {
    state.primaryNavContent = [];
    state.primaryNavContent.push(activeNav);
    state.activePrimaryNavIndex = 0;
  },
  setActivePrimaryNavIndex(state, newValue) {
    state.activePrimaryNavIndex = newValue;
  },
  resetPrimaryStack(state) {
    state.primaryNavContent = [];
    state.primaryNavContent.push({
      title: '',
      component: null,
    });
    state.activePrimaryNavIndex = 0;
  },
};

export const actions = {
  navigateDeeperPrimary(ctx, newNav) {
    window.clevertap.event.push('Destination', { View: newNav.title });
    ctx.commit('pushPrimaryNavContent', newNav);

    setTimeout(() => {
      ctx.commit('setActivePrimaryNavIndex', ctx.state.primaryNavContent.length - 1);
    }, 100);
  },
  navigateHigherPrimary(ctx) {
    if (ctx.state.primaryNavContent.length > 1) {
      ctx.commit('setActivePrimaryNavIndex', ctx.state.primaryNavContent.length - 2);

      setTimeout(() => {
        ctx.commit('popPrimaryNavContent');
      }, 500);
    }
  },
};
